import { createFileRoute } from "@tanstack/react-router";
import HusselavondOrganiseren from "@/pages/HusselavondOrganiseren";

export const Route = createFileRoute("/husselavond-organiseren")({
  head: () => ({
    meta: [
      { title: "Husselavond organiseren bij je tennisclub | De Hussel- en Toss App" },
      { name: "description", content: "Organiseer moeiteloos een hussel- of tossavond bij je tennisclub. Slimme automatische indelingen op basis van niveau, gespeelde rondes en tegenstanders. Geen vrijwilligers nodig." },
      { property: "og:title", content: "Husselavond organiseren bij je tennisclub | De Hussel- en Toss App" },
      { property: "og:description", content: "Organiseer moeiteloos een hussel- of tossavond bij je tennisclub. Slimme automatische indelingen op basis van niveau, gespeelde rondes en tegenstanders. Geen vrijwilligers nodig." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/husselavond-organiseren" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/husselavond-organiseren" }],
  }),
  component: HusselavondOrganiseren,
});
